import { render, staticRenderFns } from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=template&id=79cf1ad4&scoped=true"
import script from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=style&index=0&id=79cf1ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cf1ad4",
  null
  
)

export default component.exports